import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const WomensAdidasLongSleeve = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[19].productName}
				color={product.allGear[19].color}
				size={product.allGear[19].sizes}
				price={product.allGear[19].price}
				img={product.allGear[19].img}
				miniImg1={product.allGear[19].miniImg1}
				miniImg2={product.allGear[19].miniImg2}
				miniImg3={product.allGear[19].miniImg3}
			/>
		</React.Fragment>
	);
};

export default WomensAdidasLongSleeve;
